import { useEditor } from '../../store/context'

interface MacroItemProps { label: string, desc: string, onCmd: () => void }

function MacroItem({ label, desc, onCmd }: MacroItemProps) {
  return (
    <button
      type="button"
      className="macro-item"
      onClick={(e) => {
        e.preventDefault()
        onCmd()
      }}
    >
      <span className="macro-item-label">{label}</span>
      <span className="macro-item-desc">{desc}</span>
    </button>
  )
}

export function MacroDropdown() {
  const { store } = useEditor()
  function chain() {
    return store.editor().chain().focus()
  }

  return (
    <div className="macro-dropdown">
      <button type="button" className="tiptap-btn macro-btn" title="Insert macro">⊕</button>
      <div className="macro-panel" role="menu">
        <MacroItem label="{{toc}}" desc="Table of contents" onCmd={() => chain().insertMacro('toc').run()} />
        <MacroItem label="#" desc="Issue reference" onCmd={() => chain().insertContent('#').run()} />
        <MacroItem label="@" desc="Mention user" onCmd={() => chain().insertContent('@').run()} />
        <MacroItem label="▸ Collapse" desc="Collapsible section" onCmd={() => chain().insertBlockMacro({}).run()} />
        <MacroItem label="[[…]]" desc="Wiki link" onCmd={() => store.openWikiLinkDialog()} />
      </div>
    </div>
  )
}
